module.exports = __webpack_public_path__ + "img/hr-red-asterisk-03.34610348.png";